import {css} from "@emotion/react";

export const columnRoot = css`
    padding-left: 48px;
    padding-right: 32px;
    justify-content: space-between;
    min-height: 100px;
    height: 100%;
`;